import React, { ReactNode } from 'react';
import clsx from 'clsx';

export interface Props<T> {
  value: T;
  selected?: boolean;
  children: ReactNode;
  onClick?: () => void;
}

export default function ToggleButton<T extends string | number>({
  value,
  selected,
  onClick,
  children,
}: Props<T>) {
  return (
    <button
      className={clsx('toggle-button-group__button', {
        'toggle-button-group__button_selected': selected,
      })}
      data-value={value}
      onClick={onClick}
      aria-pressed={selected}
    >
      {children}
    </button>
  );
}
